import GlobalConfiguration from "../controllers/model/GlobalConfiguration";
import { BoardEntry } from "../controllers/model/api";


export class HelperFunctions {
    public static checkForNullOrEmpty(value: any) {
        if (typeof value != 'undefined' && value ) //&& value.trim()!== null
            return true;
        return false;
    }
  public static createBitwiseOrValue(value:string|undefined){
      if(value===undefined)
        return 0;
    var splitted = value.split("|");
    let bitwiseOr=0;
    if (splitted !== undefined) {
      for (let i = 0; i < splitted.length; i++) {
        bitwiseOr = bitwiseOr | parseInt(splitted[i]);
      }
    }
    return bitwiseOr;
  }
    public static createNewBoardEntry(message:string){
        var entry:BoardEntry = {
            category:"",
            class:"",
            date:"",
            delay:0,
            externallEndStationId:0,
            infoLong:"",
            infoShort:"",
            line:"",
            operator:"",
            plattform:"",
            time:"",
            timeProg:"",
            direction : message
          };
          return entry;
    }
    public static getDelayColorIndicator(departure: number, estimated: number){
      let returnColor : string = "#000000";
            if ((estimated - GlobalConfiguration.delayColorIndicator1.delay) >= departure)
            {
              returnColor = GlobalConfiguration.delayColorIndicator1.color;
            }
            if ((estimated - GlobalConfiguration.delayColorIndicator2.delay) >= departure)
            {
              returnColor = GlobalConfiguration.delayColorIndicator2.color;
            }
            if ((estimated - GlobalConfiguration.delayColorIndicator3.delay) >= departure)
            {
              returnColor = GlobalConfiguration.delayColorIndicator3.color;
            }
            return returnColor;
    }
}